import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { getPackageById } from '../services/packages.service';
import { apiFetch } from '../services/api';
import Navbar from '../components/Navbar';
import { FaCheck, FaTimes, FaComments, FaChevronRight, FaWeight, FaMapMarkerAlt, FaArrowRight } from 'react-icons/fa';
import PublicProfile from './PublicProfile';
import Chat from './Chat';

const STATUS_FLOW = ['pendiente', 'aceptado', 'recogido', 'entregado', 'confirmado'];

const STATUS_CONFIG = {
  pendiente:  { label: 'Pendiente',  color: '#f59e0b', bg: '#f59e0b15', bar: 1 },
  aceptado:   { label: 'Aceptado',   color: '#3b82f6', bg: '#3b82f615', bar: 2 },
  recogido:   { label: 'Recogido',   color: '#6366f1', bg: '#6366f115', bar: 3 },
  entregado:  { label: 'Entregado',  color: '#22c55e', bg: '#22c55e15', bar: 4 },
  confirmado: { label: 'Confirmado', color: '#6b7280', bg: '#6b728015', bar: 5 },
};

const Avatar = ({ name, size = 'md' }) => {
  const sizes = { sm: {width:'32px',height:'32px',fontSize:'12px'}, md: {width:'40px',height:'40px',fontSize:'14px'} };
  return (
    <div style={{...sizes[size], borderRadius:'50%', backgroundColor:'#f97316',
      display:'flex', alignItems:'center', justifyContent:'center',
      fontWeight:'bold', color:'white', flexShrink:0}}>
      {name?.charAt(0)?.toUpperCase() || '?'}
    </div>
  );
};
function ReceiverRow({ pkg, token, onViewProfile }) {
  const [receiverUser, setReceiverUser] = useState(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const buscar = async () => {
      try {
        // Si receiverId es diferente al senderId, buscar por id directamente
        const emailQuery = pkg.receiver?.email && pkg.receiverId !== pkg.senderId
          ? `email=${encodeURIComponent(pkg.receiver.email)}`
          : null;
        const phoneQuery = pkg.receiverPhone
          ? `phone=${encodeURIComponent(pkg.receiverPhone.trim())}`
          : null;
        const query = emailQuery || phoneQuery;
        if (!query) { setChecked(true); return; }
        const result = await apiFetch(`/users/buscar?${query}`, {}, token);
        if (result?.id) setReceiverUser(result);
      } catch {
        // No encontrado — es externo
      } finally {
        setChecked(true);
      }
    };
    buscar();
  }, [pkg, token]);

  // Cargando
  if (!checked) return (
    <div className="flex items-center gap-3">
      <div style={{width:'40px', height:'40px', borderRadius:'50%', backgroundColor:'#2a2d35', flexShrink:0}} />
      <p style={{color:'#3a3d45', fontSize:'12px'}}>Buscando receptor...</p>
    </div>
  );

  // Tiene cuenta en SenDViGo
  if (receiverUser) return (
    <div className="flex items-center gap-3">
      <Avatar name={receiverUser.name} />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <p className="text-white font-semibold text-sm">{receiverUser.name}</p>
          <span style={{backgroundColor:'#6366f115', color:'#818cf8',
            fontSize:'10px', fontWeight:'600', padding:'1px 8px', borderRadius:'20px'}}>
            Recibe
          </span>
        </div>
        <p style={{color:'#6b7280', fontSize:'12px'}} className="truncate">{receiverUser.email}</p>
      </div>
      <button onClick={() => onViewProfile(receiverUser.id)}
        style={{width:'32px', height:'32px', borderRadius:'10px', backgroundColor:'#111318',
          border:'1px solid #2a2d35', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0}}>
        <FaChevronRight style={{color:'#f97316', fontSize:'10px'}} />
      </button>
    </div>
  );

  // Externo — solo teléfono, sin cuenta
  return (
    <div>
      <div className="flex items-center gap-3">
        <div style={{width:'40px', height:'40px', borderRadius:'50%', backgroundColor:'#1e293b',
          border:'1px dashed #2a2d35', display:'flex', alignItems:'center', justifyContent:'center',
          flexShrink:0, fontSize:'16px'}}>
          👤
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <p className="text-white font-semibold text-sm">
              {pkg.receiverName || 'Receptor externo'}
            </p>
            <span style={{backgroundColor:'#2a2d35', color:'#6b7280',
              fontSize:'10px', padding:'1px 8px', borderRadius:'20px'}}>
              Recibe
            </span>
          </div>
          {pkg.receiverPhone && (
            <p style={{color:'#6b7280', fontSize:'12px'}}>📞 {pkg.receiverPhone}</p>
          )}
        </div>
        {pkg.receiverPhone && (
<a href={`https://wa.me/34${pkg.receiverPhone.replace(/\D/g,'')}?text=${encodeURIComponent(
  `¡Hola! Te escribo desde SenDViGo 🚗📦\n\nTe envío este mensaje porque tengo un paquete para ti y voy a llevártelo.\n\n¿Todavía no conoces SenDViGo? Es la mayor red de favores entre particulares — envía lo que quieras sin intermediarios, directo y el mismo día. Únete a nuestra comunidad en sendvigo.com 🤝\n\n`
)}`}            target="_blank" rel="noopener noreferrer"
            style={{width:'32px', height:'32px', borderRadius:'10px', backgroundColor:'#25d36615',
              border:'1px solid #25d36640', display:'flex', alignItems:'center', justifyContent:'center',
              flexShrink:0, fontSize:'14px', textDecoration:'none'}}>
            📱
          </a>
        )}
      </div>
      <p style={{color:'#3a3d45', fontSize:'11px', marginTop:'8px', paddingLeft:'52px'}}>
        Aún no está en SenDViGo — puedes contactarle directamente por WhatsApp
      </p>
    </div>
  );
}

export default function PackageDetail({ packageId, onBack, openChatDirecto, onOpenPackage }) {
  const { token, user } = useAuth();
  const [pkg, setPkg] = useState(null);
  const [message, setMessage] = useState('');
  const [viewingProfile, setViewingProfile] = useState(null);
  const [showChat, setShowChat] = useState(openChatDirecto || false);
  // ESTADO VERIFICACION — controla si ya respondió a la pregunta de identidad
  const [verificacionRespondida, setVerificacionRespondida] = useState(false);
  const [solicitudes, setSolicitudes] = useState([]);

  useEffect(() => {
    getPackageById(packageId, token).then(setPkg).catch(() => setMessage('Error cargando detalle'));
  }, [packageId, token]);

  useEffect(() => {
    if (pkg && openChatDirecto) setShowChat(true);
  }, [pkg, openChatDirecto]);

  useEffect(() => {
    if (!pkg || pkg.senderId !== user?.id || pkg.status !== 'pendiente') return;
    apiFetch(`/packages/${packageId}/solicitudes`, {}, token).then(setSolicitudes).catch(() => {});
  }, [pkg, packageId, token, user]);

  const [advancing, setAdvancing] = useState(false);

  const handleAdvanceStatus = async () => {
    if (advancing) return;
    const nextStatus = STATUS_FLOW[STATUS_FLOW.indexOf(pkg.status) + 1];
    if (!nextStatus) return;
    setAdvancing(true);
    try {
      const updated = await apiFetch(`/packages/${pkg.id}/status`,
        { method: 'PUT', body: JSON.stringify({ status: nextStatus }) }, token);
      setPkg(updated);
    } catch { setMessage('Error actualizando estado'); }
    setAdvancing(false);
  };

  const handleResponderSolicitud = async (solicitudId, accion) => {
    try {
      await apiFetch(`/packages/${pkg.id}/solicitar/${solicitudId}`,
        { method: 'PUT', body: JSON.stringify({ accion }) }, token);
      if (accion === 'aceptar') {
        const updated = await getPackageById(packageId, token);
        setPkg(updated);
        setSolicitudes([]);
      } else {
        setSolicitudes(prev => prev.filter(s => s.id !== solicitudId));
      }
    } catch { setMessage('Error procesando la solicitud'); }
  };

  if (viewingProfile) return <PublicProfile userId={viewingProfile} onBack={() => setViewingProfile(null)} />;
  if (showChat && pkg) return (
    <Chat
      packageId={pkg.id}
      packageInfo={pkg}
      onBack={() => { setShowChat(false); if (openChatDirecto) onBack(); }}
      onOpenDetail={() => setShowChat(false)}
      onViewProfile={(userId) => { setShowChat(false); setViewingProfile(userId); }}
    />
  );

  if (!pkg) return (
    <div className="min-h-screen" style={{backgroundColor: '#111318'}}>
      <Navbar onBack={onBack} onOpenPackage={onOpenPackage} />
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <div style={{width:'32px', height:'32px', border:'2px solid #f97316',
            borderTopColor:'transparent', borderRadius:'50%', animation:'spin 1s linear infinite'}}
            className="mx-auto mb-3 animate-spin" />
          <p style={{color:'#6b7280', fontSize:'14px'}}>Cargando...</p>
        </div>
      </div>
    </div>
  );

  const isDriver = pkg.driverId === user?.id;
  const isSender = pkg.senderId === user?.id;
  const nextStatus = STATUS_FLOW[STATUS_FLOW.indexOf(pkg.status) + 1];
  const canAdvance = (isDriver && ['aceptado','recogido'].includes(pkg.status)) ||
                     (isSender && pkg.status === 'entregado');
  const statusCfg = STATUS_CONFIG[pkg.status];

  return (
    <div className="min-h-screen pb-10" style={{backgroundColor: '#111318'}}>
      <Navbar onBack={onBack} onOpenPackage={onOpenPackage} />

      <div className="max-w-lg mx-auto px-4 pt-5">
        {message && (
          <div className="mb-4 px-4 py-2 rounded-xl text-sm"
            style={{backgroundColor:'#ff000015', border:'1px solid #ff000030', color:'#f87171'}}>
            {message}
          </div>
        )}

        {/* Header */}
        <div className="mb-4">
          <p style={{color:'#6b7280', fontSize:'12px'}} className="mb-0.5">
            ENV-{String(pkg.id).padStart(4,'0')}
          </p>
          <h1 className="text-white font-semibold text-2xl">{pkg.from} → {pkg.to}</h1>
        </div>

        {/* Estado + progreso */}
        <div className="rounded-2xl p-4 mb-3" style={{backgroundColor:'#1a1d24', border:'1px solid #2a2d35'}}>
          <div className="flex items-center justify-between mb-4">
            <span style={{color:statusCfg.color, backgroundColor:statusCfg.bg,
              fontSize:'11px', fontWeight:'700', padding:'4px 12px', borderRadius:'20px'}}>
              {statusCfg.label}
            </span>
            <span style={{color:'#6b7280', fontSize:'12px'}}>
              Paso {statusCfg.bar} de 5
            </span>
          </div>
          {/* Barra */}
          <div style={{height:'4px', backgroundColor:'#2a2d35', borderRadius:'4px', overflow:'hidden'}}>
            <div style={{height:'100%', backgroundColor:'#f97316', borderRadius:'4px',
              width:`${((statusCfg.bar-1)/4)*100}%`, transition:'width 0.5s ease'}} />
          </div>
          <div className="flex justify-between mt-2">
            {STATUS_FLOW.map((s,i) => (
              <span key={s} style={{fontSize:'9px', color: i < statusCfg.bar ? '#f97316' : '#3a3d45'}}>
                {STATUS_CONFIG[s].label}
              </span>
            ))}
          </div>
        </div>

        {/* Info paquete */}
        <div className="rounded-2xl p-4 mb-3" style={{backgroundColor:'#1a1d24', border:'1px solid #2a2d35'}}>
          <p style={{color:'#f97316', fontSize:'11px', fontWeight:'600',
            textTransform:'uppercase', letterSpacing:'0.06em', marginBottom:'12px'}}>
            📦 Qué se envía
          </p>
          <div className="flex gap-4">
            <div className="flex items-center gap-2">
              <FaWeight style={{color:'#f97316', fontSize:'11px'}} />
              <div>
                <p style={{color:'#6b7280', fontSize:'10px'}}>Peso</p>
                <p className="text-white text-sm font-semibold">{pkg.weight} kg</p>
              </div>
            </div>
            <div>
              <p style={{color:'#6b7280', fontSize:'10px'}}>Contribución al viaje</p>
              <p style={{color:'#f97316'}} className="text-sm font-bold">{pkg.price}€</p>
            </div>
          </div>
          {pkg.description && (
            <p style={{color:'#9ca3af', fontSize:'13px', marginTop:'10px',
              paddingTop:'10px', borderTop:'1px solid #2a2d35'}}>
              {pkg.description}
            </p>
          )}
          {pkg.mensajePersonal && (
            <div style={{marginTop:'10px', paddingTop:'10px', borderTop:'1px solid #2a2d35'}}>
              <p style={{color:'#6b7280', fontSize:'10px', marginBottom:'4px'}}>Mensaje</p>
              <p style={{color:'#d1d5db', fontSize:'13px', fontStyle:'italic', lineHeight:'1.5',
  wordBreak:'break-word', overflowWrap:'break-word', whiteSpace:'pre-wrap'}}>
  "{pkg.mensajePersonal}"
</p>
            </div>
          )}
        </div>

        {/* Participantes */}
<div className="rounded-2xl p-4 mb-3" style={{backgroundColor:'#1a1d24', border:'1px solid #2a2d35', overflow:'hidden'}}>
            <p style={{color:'#f97316', fontSize:'11px', fontWeight:'600',
            textTransform:'uppercase', letterSpacing:'0.06em', marginBottom:'12px'}}>
            👤 Participantes
          </p>

          {/* Remitente */}
          <div className="flex items-center gap-3">
            <Avatar name={pkg.sender?.name} />
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <p className="text-white font-semibold text-sm">{pkg.sender?.name}</p>
                <span style={{backgroundColor:'#f9731615', color:'#f97316',
                  fontSize:'10px', fontWeight:'600', padding:'1px 8px', borderRadius:'20px'}}>
                  Solicita ayuda
                </span>
              </div>
              <p style={{color:'#6b7280', fontSize:'12px'}} className="truncate">{pkg.sender?.email}</p>
            </div>
            {!isSender && (
              <button onClick={() => setViewingProfile(pkg.sender?.id)}
                style={{width:'32px', height:'32px', borderRadius:'10px', backgroundColor:'#111318',
                  border:'1px solid #2a2d35', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0}}>
                <FaChevronRight style={{color:'#f97316', fontSize:'10px'}} />
              </button>
            )}
          </div>

          {/* Viajero */}
          {pkg.driver && (
            <div className="flex items-center gap-3" style={{paddingTop:'10px', marginTop:'10px', borderTop:'1px solid #2a2d35'}}>
              <Avatar name={pkg.driver?.name} />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <p className="text-white font-semibold text-sm">{pkg.driver?.name}</p>
                  <span style={{backgroundColor:'#3b82f615', color:'#3b82f6',
                    fontSize:'10px', fontWeight:'600', padding:'1px 8px', borderRadius:'20px'}}>
                    Viajero
                  </span>
                </div>
                <p style={{color:'#6b7280', fontSize:'12px'}} className="truncate">{pkg.driver?.email}</p>
              </div>
              {pkg.driver.id !== user?.id && (
                <button onClick={() => setViewingProfile(pkg.driver?.id)}
                  style={{width:'32px', height:'32px', borderRadius:'10px', backgroundColor:'#111318',
                    border:'1px solid #2a2d35', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0}}>
                  <FaChevronRight style={{color:'#f97316', fontSize:'10px'}} />
                </button>
              )}
            </div>
          )}

          {/* Receptor — solo remitente y viajero asignado */}
          {(isSender || isDriver) && (pkg.receiverPhone || pkg.receiver?.email) && (
            <div style={{paddingTop:'10px', marginTop:'10px', borderTop:'1px solid #2a2d35'}}>
              <ReceiverRow
                pkg={pkg}
                token={token}
                onViewProfile={setViewingProfile}
              />
            </div>
          )}
        </div>

        {/* Solicitudes */}
        {isSender && solicitudes.length > 0 && (
          <div className="rounded-2xl p-4 mb-3" style={{backgroundColor:'#1a1d24', border:'1px solid #2a2d35'}}>
            <div className="flex items-center justify-between mb-3">
              <p style={{color:'#f97316', fontSize:'11px', fontWeight:'600',
                textTransform:'uppercase', letterSpacing:'0.06em'}}>
                🤝 Se ofrecen a ayudarte
              </p>
              <span style={{backgroundColor:'#f97316', color:'white', fontSize:'10px',
                fontWeight:'700', width:'20px', height:'20px', borderRadius:'50%',
                display:'flex', alignItems:'center', justifyContent:'center'}}>
                {solicitudes.length}
              </span>
            </div>
            {solicitudes.map(sol => (
              <div key={sol.id} className="mb-3 last:mb-0 rounded-xl p-3"
                style={{backgroundColor:'#111318', border:'1px solid #2a2d35'}}>
                <div className="flex items-center gap-3 mb-3">
                  <Avatar name={sol.driver?.name} size="sm" />
                  <div className="flex-1">
                    <p className="text-white font-semibold text-sm">{sol.driver?.name}</p>
                    <p style={{color:'#6b7280', fontSize:'11px'}}>Se ofrece a llevar tu paquete 🤝</p>
                  </div>
                  <button onClick={() => setViewingProfile(sol.driver?.id)}
                    style={{fontSize:'11px', color:'#f97316', border:'1px solid #f9731640',
                      padding:'4px 10px', borderRadius:'8px', backgroundColor:'transparent'}}>
                    Ver perfil
                  </button>
                </div>
                <div className="flex gap-2">
                  <button onClick={() => handleResponderSolicitud(sol.id, 'aceptar')}
                    style={{flex:1, backgroundColor:'#22c55e', color:'white', fontWeight:'600',
                      padding:'9px', borderRadius:'12px', fontSize:'12px',
                      display:'flex', alignItems:'center', justifyContent:'center', gap:'6px'}}>
                    <FaCheck /> Aceptar ayuda
                  </button>
                  <button onClick={() => handleResponderSolicitud(sol.id, 'rechazar')}
                    style={{flex:1, backgroundColor:'#2a2d35', color:'#9ca3af', fontWeight:'600',
                      padding:'9px', borderRadius:'12px', fontSize:'12px',
                      display:'flex', alignItems:'center', justifyContent:'center', gap:'6px'}}>
                    <FaTimes /> Declinar
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

{/* Acciones */}
{(() => {
  const isReceiver = pkg.receiverId === user?.id && pkg.receiverId !== pkg.senderId;
  const puedeChat = pkg.driver && (isSender || isDriver || isReceiver);
  if (!canAdvance && !puedeChat) return null;
  return (
    <div className="flex flex-col gap-2">
      {canAdvance && (
        <button onClick={handleAdvanceStatus} disabled={advancing}
          style={{backgroundColor: advancing ? '#6b7280' : '#f97316', width:'100%', color:'white',
            fontWeight:'600', padding:'14px', borderRadius:'14px', fontSize:'14px',
            cursor: advancing ? 'default' : 'pointer'}}>
          ✓ Marcar como {STATUS_CONFIG[nextStatus]?.label}
        </button>
      )}
      {puedeChat && (
        <button onClick={() => setShowChat(true)}
          style={{width:'100%', backgroundColor:'#1a1d24', color:'white', fontWeight:'600',
            padding:'14px', borderRadius:'14px', fontSize:'14px',
            border:'1px solid #2a2d35', display:'flex', alignItems:'center', justifyContent:'center', gap:'8px'}}>
          <FaComments style={{color:'#f97316'}} /> Chat del envío
        </button>
      )}
    </div>
  );
})()}

{/* BLOQUE VERIFICACION — cada participante verifica a quien corresponde */}
{pkg.status === 'entregado' && (() => {
  const userToVerify = isSender ? pkg.driverId : isDriver ? pkg.senderId : null;
  if (!userToVerify) return null;
  return (
    <div style={{backgroundColor:'#111318', border:'1px solid #2a2d35', borderRadius:'14px', padding:'16px', marginTop:'8px'}}>
      {verificacionRespondida ? (
        <p style={{color:'#22c55e', fontSize:'13px', fontWeight:'600', textAlign:'center'}}>
          ✓ Gracias por tu valoración
        </p>
      ) : (
        <>
          <p style={{color:'white', fontWeight:'700', fontSize:'13px', marginBottom:'8px'}}>
            ¿La persona que participó en el envío coincide con su foto de perfil?
          </p>
          <div style={{display:'flex', gap:'8px'}}>
            {/* BOTÓN SÍ COINCIDE */}
            <button onClick={async (e) => {
              e.stopPropagation();
              try {
                await apiFetch(`/users/${userToVerify}/verificar`, { method: 'POST', body: JSON.stringify({ coincide: true }) }, token);
                setVerificacionRespondida(true);
              } catch (err) {
                console.error('ERROR verificar:', err.message);
              }
            }}
              style={{flex:1, backgroundColor:'#22c55e15', border:'1px solid #22c55e30',
                color:'#22c55e', fontWeight:'600', padding:'10px', borderRadius:'12px', fontSize:'13px', cursor:'pointer'}}>
              ✓ Sí, coincide
            </button>
            {/* BOTÓN NO COINCIDE */}
            <button onClick={async (e) => {
              e.stopPropagation();
              try {
                await apiFetch(`/users/${userToVerify}/verificar`, { method: 'POST', body: JSON.stringify({ coincide: false }) }, token);
                setVerificacionRespondida(true);
              } catch (err) {
                console.error('ERROR verificar:', err.message);
              }
            }}
              style={{flex:1, backgroundColor:'#f8717115', border:'1px solid #f8717130',
                color:'#f87171', fontWeight:'600', padding:'10px', borderRadius:'12px', fontSize:'13px', cursor:'pointer'}}>
              ✗ No coincide
            </button>
          </div>
        </>
      )}
    </div>
  );
})()}
      </div>
    </div>
  );
}
